<template>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 col-xl-12" style="margin-top: 20px;">
                <div class="card">
                    <div class="card-header">
                        <CfdiFiltersBar
                            style="float: right; font-size: 12px; padding: 2px 10px"
                            v-model="filters"
                            :nature="nature"
                            :group="tab"
                            :showSearch="true"
                            :showPeriod="true"
                            :showAdvanced="true"
                            :showStatus="true"
                            :showMethod="false"
                            :showExport="false"
                            @apply="onApplyFilters"
                        />
                        <h3>CFDIs por Cobrar</h3>
                    </div>
                    <div class="card-body receivable-body">
                        <div class="row summary-block">
                            <div class="col-sm-12 col-xl-6">
                                <div class="kpi-grid-panel">
                                    <div class="kpi-card kpi-card--primary">
                                        <div class="kpi-card-top">
                                            <div>
                                                <div class="kpi-title">CFDIs Totales</div>
                                                <div class="kpi-value">{{ formatInteger(kpis.receivable_cfdis) }}</div>
                                            </div>
                                        </div>
                                        <div class="kpi-footnote">Facturas emitidas PPD sin cobro total</div>
                                    </div>

                                    <div class="kpi-card kpi-card--success">
                                        <div class="kpi-card-top">
                                            <div>
                                                <div class="kpi-title">Monto Total</div>
                                                <div class="kpi-value" :style="kpiValueStyle(kpis.receivable_total)">{{ formatCurrency(kpis.receivable_total) }}</div>
                                            </div>
                                        </div>
                                        <div class="kpi-footnote">Total por cobrar en MXN</div>
                                    </div>

                                    <div class="kpi-card kpi-card--warning">
                                        <div class="kpi-card-top">
                                            <div>
                                                <div class="kpi-title"><30 dias</div>
                                                <div class="kpi-value" :style="kpiValueStyle(agingUnder30.amount)">{{ formatCurrency(agingUnder30.amount) }}</div>
                                            </div>
                                        </div>
                                        <div class="kpi-footnote">{{ formatInteger(agingUnder30.count) }} CFDIs pendientes</div>
                                    </div>

                                    <div class="kpi-card kpi-card--danger">
                                        <div class="kpi-card-top">
                                            <div>
                                                <div class="kpi-title">+30 dias</div>
                                                <div class="kpi-value" :style="kpiValueStyle(agingOver30.amount)">{{ formatCurrency(agingOver30.amount) }}</div>
                                            </div>
                                        </div>
                                        <div class="kpi-footnote">{{ formatInteger(agingOver30.count) }} CFDIs pendientes</div>
                                    </div>

                                    <div class="kpi-card kpi-card--info">
                                        <div class="kpi-card-top">
                                            <div>
                                                <div class="kpi-title">Clientes Totales</div>
                                                <div class="kpi-value">{{ formatInteger(kpis.total_customers) }}</div>
                                            </div>
                                        </div>
                                        <div class="kpi-footnote">Cantidad de clientes con saldo pendiente</div>
                                    </div>

                                    <div class="kpi-card kpi-card--neutral">
                                        <div class="kpi-card-top">
                                            <div>
                                                <div class="kpi-title">+60 dias</div>
                                                <div class="kpi-value" :style="kpiValueStyle(agingOver60.amount)">{{ formatCurrency(agingOver60.amount) }}</div>
                                            </div>
                                        </div>
                                        <div class="kpi-footnote">{{ formatInteger(agingOver60.count) }} CFDIs pendientes</div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-xl-6">
                                <div class="card chart-card h-100">
                                    <div class="card-header chart-card-header">
                                        <h5 class="mb-0">Top clientes por monto</h5>
                                    </div>
                                    <div class="card-body chart-card-body">
                                        <apexchart
                                            height="300"
                                            type="pie"
                                            :options="pieChartOptions"
                                            :series="pieChartSeries"
                                        ></apexchart>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <CfdiTable
                            :items="cfdis"
                            :fields="fields"
                            :rowActions="tableActions"
                            empty-text="No se encontraron CFDIs por cobrar."
                            @row-action="onRowAction"
                        />

                        <div v-if="markPaidModal.visible" class="confirm-overlay" @click.self="closeMarkPaidModal">
                            <div class="confirm-card">
                                <h5>Marcar CFDI como pagado</h5>
                                <p>
                                    Se marcará como pagado el CFDI
                                    <strong>{{ markPaidModal.uuid || '-' }}</strong>
                                    y dejará de aparecer en este listado.
                                </p>
                                <p class="confirm-note">
                                    Esta acción no modifica el estatus oficial del SAT.
                                </p>
                                <div class="confirm-actions">
                                    <button class="btn btn-outline-secondary btn-sm" :disabled="markPaidModal.loading" @click="closeMarkPaidModal">Cancelar</button>
                                    <button class="btn btn-success btn-sm" :disabled="markPaidModal.loading" @click="confirmMarkAsPaid">
                                        {{ markPaidModal.loading ? 'Procesando...' : 'Confirmar' }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <ul class="pagination pagination-sm pagination-primary" style="margin-top: 10px; float: right;" v-if="paginator.total_pages > 1">
                            <li class="page-item"><a class="page-link" :style="paginator.current_page == 1 || isLoading ? 'color: gray !important' : ''" href="javascript:void(0)" @click="!isLoading && paginator.current_page > 1 && changePage(paginator.current_page - 1)">Anterior</a></li>
                            <li class="page-item" v-for="page in pagesToShow" :key="page" @click="!isLoading && paginator.current_page != page && changePage(page)"><a class="page-link" href="javascript:void(0)">{{ page }}</a></li>
                            <li class="page-item"><a class="page-link" :style="paginator.current_page == paginator.total_pages || isLoading ? 'color: gray !important' : ''" href="javascript:void(0)" @click="!isLoading && paginator.current_page < paginator.total_pages && changePage(paginator.current_page + 1)">Siguiente</a></li>
                        </ul>

                        <div v-if="isLoading" class="receivable-loading-overlay">
                            <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
                            <div class="receivable-loading-text">Consultando CFDIs por cobrar...</div>
                            <div v-if="showSlowLoadingHint" class="receivable-loading-hint">Esta consulta puede tardar algunos segundos por el volumen de informacion.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import CfdiFiltersBar from "@/components/cfdis/CfdiFiltersBar.vue";
import CfdiTable from "@/components/cfdis/CfdiTable.vue";
import { getGlobalPeriod } from '@/services/globalPeriod';

import ws from "@/services/cfdis"

export default {
    components: {
        CfdiFiltersBar,
        CfdiTable,
    },
    data() {
        return {
            rfc: '',
            period: '',
            nature: 'issued',
            tab: 'incomes',
            filters: {
                rfc: '',
                nature: 'issued',
                group: 'incomes',
                period: '',
                search: '',
                status: '1',
                method: 'PPD',
                advanced: [],
            },
            cfdis: [],
            fields: [],
            counters: {
                I: 0,
                E: 0,
                P: 0,
                N: 0,
            },
            kpis: {
                receivable_cfdis: 0,
                receivable_total: 0,
                over_30_days: 0,
                over_60_days: 0,
                total_customers: 0,
                aging_chart: {
                    counts: [0, 0, 0],
                    amounts: [0, 0, 0],
                },
                customers_pie: {
                    labels: [],
                    values: [],
                },
            },
            paginator: {
                current_page: 1,
                per_page: 30,
                total_pages: 1,
                total_items: 0,
            },
            isLoading: false,
            showSlowLoadingHint: false,
            slowLoadingTimer: null,
            viewportWidth: window.innerWidth,
            markPaidModal: {
                visible: false,
                uuid: '',
                loading: false,
            },
        }
    },
    mounted: async function() {
        this.rfc = localStorage.getItem('rfc');
        this.period = getGlobalPeriod();

        this.filters.rfc = this.rfc;
        this.filters.nature = this.nature;
        this.filters.group = this.tab;
        this.filters.method = 'PPD';
        this.filters.period = this.period;

        await this.refreshItems();

        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        if(this.slowLoadingTimer){
            clearTimeout(this.slowLoadingTimer);
            this.slowLoadingTimer = null;
        }

        window.removeEventListener('resize', this.handleResize);
    },
    computed: {
        pieChartSeries() {
            return this.kpis?.customers_pie?.values || [];
        },
        pieChartOptions() {
            const labels = this.kpis?.customers_pie?.labels || [];
            const tusCfdisPalette = [
                '#2F8AB6',
                '#25A86C',
                '#7366FF',
                '#3FB5CC',
                '#1E8C59',
                '#4C7EEB',
                '#5CC6B2',
                '#6D91F5',
                '#2DA0D1',
                '#40B884',
            ];
            return {
                chart: {
                    type: 'pie',
                    toolbar: { show: false },
                },
                labels,
                colors: tusCfdisPalette,
                stroke: {
                    colors: ['#FFFFFF'],
                    width: 2,
                },
                legend: {
                    show: false,
                },
                dataLabels: {
                    enabled: true,
                    formatter: (value) => `${Number(value || 0).toFixed(1)}%`,
                },
                tooltip: {
                    y: {
                        formatter: (value) => this.formatCurrency(value),
                    },
                },
                noData: { text: 'Sin datos de clientes' },
            };
        },
        agingUnder30() {
            return {
                count: Number(this.kpis?.aging_chart?.counts?.[0] || 0),
                amount: Number(this.kpis?.aging_chart?.amounts?.[0] || 0),
            };
        },
        agingOver30() {
            return {
                count: Number(this.kpis?.aging_chart?.counts?.[1] || 0),
                amount: Number(this.kpis?.aging_chart?.amounts?.[1] || 0),
            };
        },
        agingOver60() {
            return {
                count: Number(this.kpis?.aging_chart?.counts?.[2] || 0),
                amount: Number(this.kpis?.aging_chart?.amounts?.[2] || 0),
            };
        },
        tableActions() {
            return [
                {
                    key: 'mark-paid',
                    label: 'Marcar como Pagado',
                    buttonText: 'Pagar',
                    className: 'btn-outline-success',
                    iconClass: 'fa fa-check-circle',
                    popoverText: 'Marcar CFDI como pagado',
                    popoverTrigger: 'hover focus',
                    popoverPlacement: 'top',
                },
            ];
        },
        pagesToShow () {
            const total = this.paginator.total_pages
            const current = this.paginator.current_page
            const delta = 2

            if (total === 0) return []

            let start = current - delta
            let end = current + delta

            if (start < 1) {
                end = Math.min(end + (1 - start), total)
                start = 1
            }

            if (end > total) {
                start = Math.max(1, start - (end - total))
                end = total
            }

            const pages = []
            for (let i = start; i <= end; i++) {
                pages.push(i)
            }
            return pages
        },
    },
    methods: {
        handleResize() {
            this.viewportWidth = window.innerWidth;
        },
        kpiValueStyle(value) {
            const amount = Math.abs(Number(value || 0));
            const width = Number(this.viewportWidth || window.innerWidth || 1920);

            if(width <= 1400){
                if(amount >= 1000000) return { fontSize: '18px' };
                if(amount >= 100000) return { fontSize: '20px' };
                return { fontSize: '22px' };
            }

            if(width <= 1600){
                if(amount >= 1000000) return { fontSize: '20px' };
                if(amount >= 100000) return { fontSize: '22px' };
                return { fontSize: '24px' };
            }

            if(amount >= 1000000) return { fontSize: '22px' };
            if(amount >= 100000) return { fontSize: '24px' };
            return { fontSize: '26px' };
        },
        formatInteger(value){
            return Number(value || 0).toLocaleString('es-MX');
        },
        formatCurrency(value){
            return Number(value || 0).toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        async refreshItems(){
            this.filters.nature = this.nature;
            this.filters.group = this.tab;
            this.filters.method = 'PPD';

            this.isLoading = true;
            this.showSlowLoadingHint = false;

            if(this.slowLoadingTimer){
                clearTimeout(this.slowLoadingTimer);
            }

            this.slowLoadingTimer = setTimeout(() => {
                this.showSlowLoadingHint = true;
            }, 2500);

            try{
                const response = await ws.getReceivableCfdis(this.rfc, this.filters, this.paginator.current_page);

                if(response && response.type == 'success'){
                    this.cfdis = response.data || [];
                    this.fields = [
                        { code: 'fecha', name: 'Fecha', type: 'date', visible: true },
                        { code: 'uuid', name: 'UUID', type: 'text', visible: true },
                        { code: 'receptor_info', name: 'RFC / Receptor', type: 'multiline', visible: true },
                        { code: 'saldo_inicial', name: 'Total (Saldo Inicial)', type: 'currency', visible: true },
                        { code: 'monto_pagado', name: 'Monto Pagado', type: 'currency', visible: true },
                        { code: 'balance', name: 'Saldo Insoluto', type: 'currency', visible: true },
                    ];
                    this.counters = response.counters || { I: 0, E: 0, P: 0, N: 0 };

                    this.kpis = {
                        receivable_cfdis: Number(response?.kpis?.receivable_cfdis ?? 0),
                        receivable_total: Number(response?.kpis?.receivable_total ?? 0),
                        over_30_days: Number(response?.kpis?.over_30_days ?? 0),
                        over_60_days: Number(response?.kpis?.over_60_days ?? 0),
                        total_customers: Number(response?.kpis?.total_customers ?? 0),
                        aging_chart: {
                            counts: response?.kpis?.aging_chart?.counts ?? [0, 0, 0],
                            amounts: response?.kpis?.aging_chart?.amounts ?? [0, 0, 0],
                        },
                        customers_pie: {
                            labels: response?.kpis?.customers_pie?.labels ?? [],
                            values: response?.kpis?.customers_pie?.values ?? [],
                        },
                    };

                    const items = Number(this.counters.I || 0);
                    this.paginator = {
                        current_page: this.paginator.current_page,
                        per_page: this.paginator.per_page,
                        total_pages: Math.max(1, Math.ceil(items / this.paginator.per_page)),
                        total_items: items,
                    };
                }
            }
            finally{
                this.isLoading = false;
                this.showSlowLoadingHint = false;

                if(this.slowLoadingTimer){
                    clearTimeout(this.slowLoadingTimer);
                    this.slowLoadingTimer = null;
                }
            }
        },
        async onApplyFilters(){
            this.paginator.current_page = 1;
            await this.refreshItems();
        },
        async changePage(page){
            this.paginator.current_page = page;
            await this.refreshItems();
        },
        onRowAction(payload){
            const actionKey = payload?.action?.key || '';
            const uuid = String(payload?.item?.uuid || '').trim().toUpperCase();

            if(actionKey !== 'mark-paid' || !uuid){
                return;
            }

            this.markPaidModal.visible = true;
            this.markPaidModal.uuid = uuid;
            this.markPaidModal.loading = false;
        },
        closeMarkPaidModal(){
            if(this.markPaidModal.loading){
                return;
            }

            this.markPaidModal.visible = false;
            this.markPaidModal.uuid = '';
        },
        async confirmMarkAsPaid(){
            const uuid = this.markPaidModal.uuid;
            if(!uuid || this.markPaidModal.loading){
                return;
            }

            this.markPaidModal.loading = true;

            try{
                const response = await ws.markCfdiAsPaid(this.rfc, uuid);
                if(response && response.type === 'success'){
                    this.markPaidModal.visible = false;
                    this.markPaidModal.uuid = '';

                    if(this.cfdis.length === 1 && this.paginator.current_page > 1){
                        this.paginator.current_page -= 1;
                    }

                    await this.refreshItems();
                    return;
                }

                alert('No se pudo marcar el CFDI como pagado.');
            }
            catch(error){
                alert('No se pudo marcar el CFDI como pagado.');
            }
            finally{
                this.markPaidModal.loading = false;
            }
        },
    }
}
</script>

<style scoped>
.card .card-header {
    padding-top: 20px !important;
    padding-bottom: 10px !important;
}

.kpi-row{
    margin-bottom: 14px;
}

.summary-block{
    margin-bottom: 14px;
    align-items: stretch;
}

.summary-block > div{
    display: flex;
}

.kpi-grid-panel{
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: repeat(3, minmax(0, 1fr));
    gap: 10px;
}

.kpi-card{
    --kpi-accent: var(--theme-deafult, #3f7ee8);
    border: 1px solid var(--sidebar-border);
    border-radius: 10px;
    background: var(--white);
    padding: 11px 12px;
    margin-bottom: 0;
    position: relative;
    overflow: hidden;
    min-height: 98px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.kpi-card::before{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, var(--kpi-accent), transparent);
    opacity: 0.9;
}

.kpi-card--primary{
    --kpi-accent: var(--theme-deafult, #3f7ee8);
}

.kpi-card--success{
    --kpi-accent: var(--theme-secondary, #25a86c);
}

.kpi-card--warning{
    --kpi-accent: #c7891f;
}

.kpi-card--danger{
    --kpi-accent: #c94949;
}

.kpi-card--info{
    --kpi-accent: #2f8ab6;
}

.kpi-card--neutral{
    --kpi-accent: #6a7684;
}

.kpi-card-top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.kpi-title{
    font-size: 11px;
    font-weight: 600;
    color: var(--theme-font-color);
    opacity: 0.75;
    margin-bottom: 2px;
}

.kpi-value{
    font-size: 20px;
    line-height: 1;
    font-weight: 700;
    color: var(--theme-font-color);
}

.kpi-footnote{
    margin-top: 6px;
    font-size: 10px;
    color: var(--theme-font-color);
    opacity: 0.68;
}

.chart-card{
    margin-bottom: 0;
    border: 1px solid var(--sidebar-border);
    width: 100%;
}

.chart-card-header{
    padding-top: 14px !important;
    padding-bottom: 8px !important;
}

.chart-card-body{
    padding-top: 0;
}

.receivable-body{
    position: relative;
}

.receivable-loading-overlay{
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.85);
    z-index: 20;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    text-align: center;
    padding: 16px;
}

.receivable-loading-text{
    font-size: 13px;
    font-weight: 600;
    color: var(--theme-font-color);
}

.receivable-loading-hint{
    font-size: 12px;
    color: #6a7684;
    max-width: 380px;
}

@media (max-width: 991px){
    .kpi-grid-panel{
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-template-rows: unset;
    }
}

@media (max-width: 575px){
    .kpi-grid-panel{
        grid-template-columns: 1fr;
    }
}

.confirm-overlay{
    position: fixed;
    inset: 0;
    background: rgba(30, 37, 52, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1100;
    padding: 14px;
}

.confirm-card{
    width: 100%;
    max-width: 460px;
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
}

.confirm-card h5{
    margin-bottom: 10px;
}

.confirm-card p{
    font-size: 13px;
    margin-bottom: 10px;
}

.confirm-note{
    color: #6a7684;
}

.confirm-actions{
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}
</style>
